module.exports = __webpack_public_path__ + "img/CLS-P-330.565d90d2.svg";